import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Radio } from "antd";
import { useI18n } from "../../../../../contexts";
const FormServiceFieldGeneralStatus = ()=>{
    const { __ } = useI18n();
    return /*#__PURE__*/ _jsxs(Form.Item, {
        label: __("Status"),
        required: true,
        children: [
            /*#__PURE__*/ _jsx(Form.Item, {
                name: "status",
                noStyle: true,
                rules: [
                    {
                        required: true,
                        message: __("Please choose an option!")
                    }
                ],
                children: /*#__PURE__*/ _jsxs(Radio.Group, {
                    children: [
                        /*#__PURE__*/ _jsx(Radio.Button, {
                            value: "publish",
                            children: __("Enabled")
                        }),
                        /*#__PURE__*/ _jsx(Radio.Button, {
                            value: "private",
                            children: __("Disabled")
                        }),
                        /*#__PURE__*/ _jsx(Radio.Button, {
                            value: "draft",
                            children: __("Draft")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "description",
                children: __('Services with the status "Draft" or "Disabled" are not visible to the public. In addition, a draft will be highlighted in the service table so that you do not forget to configure it.')
            })
        ]
    });
};
export { FormServiceFieldGeneralStatus };
